import * as yup from 'yup';

// EY Custom Validations
yup.addMethod(yup.number, 'decimal', function(places) {
	return this.test(
		'isDecimalWithNPlaces',
		'Invalid decimal',
		(value) =>
			!isNaN(value) &&
			Math.round(value * Math.pow(10, places)) / Math.pow(10, places) === value
	);
});
//

class EYValidation {
	constructor(schema, locale) {
		this.schema = yup.object().shape(schema);
		this.locale = locale;
	}

	static mixed() {
		return yup.mixed();
	}

	static string() {
		return yup.string();
	}
	static number() {
		return yup.number();
	}
	static boolean() {
		return yup.boolean();
	}
	static date() {
		return yup.date();
	}
	static array() {
		return yup.array();
	}
	static object() {
		return yup.object();
	}
	static addMethod(schemaType, name, method) {
		return yup.addMethod(schemaType, name, method);
	}

	ValidateField(field, value) {
		return yup.reach(this.schema, field).isValidSync(value);
	}

	ValidateAll(data, fieldCallbacks = []) {
		let valid = true;
		try {
			this.schema.validateSync(data, {abortEarly: false});
		} catch (e) {
			valid = false;
			fieldCallbacks &&
				e.inner.forEach((e, i) => {
					let field = fieldCallbacks.find((f) => f.field === e.path);
					if (field) {
						field.callback && field.callback();
					}
				});
		}

		return valid;
	}
}

export default EYValidation;
